import { combineEpics } from 'redux-observable';
import orderCurrentGet from './orderCurrentGet';
import orderPlace from './orderPlace';
import orderDraftUpdate from './orderDraftUpdate';
import ordersGetAll from './ordersGetAll';
import orderDetailsGet from './orderDetailsGet';
import orderGetDocument from './orderGetDocument';
import orderSetBaseOnLiability from './orderSetBaseOnLiability';
import orderImport from './orderImport';

export default combineEpics(
    orderCurrentGet,
    orderPlace,
    orderDraftUpdate,
    ordersGetAll,
    orderDetailsGet,
    orderGetDocument,
    orderSetBaseOnLiability,
    orderImport
);



// WEBPACK FOOTER //
// ./src/application/order/epic/index.ts